module.exports = __webpack_public_path__ + "static/media/refresh-2.89f18184.svg";